export const BUYER_INTENT_ACTIVITY_ENDPOINT = '/apiui/buyerIntent/events/'
